import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

export default function GetStarted() {
  return (
    <section id="get-started" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-gradient-to-br from-blue-500 to-indigo-600 rounded-3xl overflow-hidden">
          <div className="relative px-6 py-16 sm:px-12 lg:px-16">
            <div className="relative max-w-3xl mx-auto text-center">
              <h2 className="text-3xl font-bold text-white mb-6">
                Ready to Transform Your Business?
              </h2>
              <p className="text-xl text-blue-50 mb-8">
                Join the beta program and be among the first to experience the future of AI-powered business growth.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4">
                <Link 
                  to="/signup"
                  className="bg-white text-blue-600 px-8 py-3 rounded-full hover:shadow-lg transition-all flex items-center justify-center space-x-2"
                >
                  <Sparkles className="w-5 h-5" />
                  <span>Join Beta Program</span>
                </Link>
                <button className="border-2 border-white text-white px-8 py-3 rounded-full hover:bg-white/10 transition-all flex items-center justify-center space-x-2">
                  <span>Schedule Demo</span>
                  <ArrowRight className="w-5 h-5" />
                </button>
              </div>
            </div>
            <div className="absolute top-0 right-0 -translate-y-12 translate-x-12">
              <div className="w-64 h-64 bg-white/10 rounded-full blur-3xl" />
            </div>
            <div className="absolute bottom-0 left-0 translate-y-12 -translate-x-12">
              <div className="w-64 h-64 bg-white/10 rounded-full blur-3xl" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}